import React, { Component } from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';

const CTABarButton = injectIntl(({href, intl}) => (
	<a className="cta-bar__btn" href={intl.formatMessage({id:href})} target="_blank">
		<FormattedMessage id="cta.desc" />
	</a>
));

class CTABar extends Component{

	render(){
		return (
			<div className="cta-bar">
				<p className="cta-bar__text">
					<FormattedMessage id="cta.title" />
				</p>
				<CTABarButton href={'cta.desc.link'}/>
			</div>
		);
	}
}

export default CTABar;


// WEBPACK FOOTER //
// ./src/components/common/CTABar.js